export default "__VITE_ASSET__5194c9a3__"